<script>
import { Line } from 'vue-chartjs'
import $ from 'jquery'
import tooltipPlugin from '@/components/charts/chartjs-tooltip-plugin'

export default Line.extend({
  props: ['data'],
  mounted () {
    const fontColor = $('#app').css('color')
    const fontSize = parseInt($('#app').css('font-size')) * 0.6
    const unit = this.$el.dataset.unit ? this.$el.dataset.unit : ''

    this.addPlugin(tooltipPlugin)

    this.options = {
      showAllTooltips: true,
      layout: {
        padding: {
          left: 40,
          right: 40,
          top: 40,
          bottom: 0
        }
      },
      tooltips: {
        backgroundColor: 'rgba(255,255,255,0.75)',
        titleFontColor: '#333',
        titleFontStyle: 'normal',
        titleFontSize: fontSize,
        yAlign: 'bottom',
        xAlign: 'center',
        xPadding: 6,
        yPadding: 3,
        cornerRadius: 2,
        callbacks: {
          title (tooltipItem, chart) {
            return tooltipItem[0].yLabel.toLocaleString() + unit
          },
          label () {}
        }
      },
      legend: {
        position: 'bottom',
        labels: {
          fontColor: fontColor,
          fontSize: fontSize * 1.1,
          usePointStyle: true,
          fontStyle: 'bold',
          position: 'bottom'
        }
      },
      scales: {
        yAxes: [{
          display: false
        }],
        xAxes: [{
          ticks: {
            fontColor: fontColor,
            fontSize: fontSize - 2
          }
        }]
      },
      animation: {
        easing: this.$store.state.chartAnimationEasing,
        duration: this.$store.state.chartAnimationTime
      }
    }

    this.renderChart(this.data, this.options)
  }
})
</script>



// WEBPACK FOOTER //
// src/components/charts/line-chart.vue